export const Props = () => ({
  //Объект Видео
  data: {
    type: Object,
  },
});